"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { Control, FieldErrors, UseFormRegister } from "react-hook-form";
import { Controller } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { formatPhone, type ProposalFormValues } from "@/lib/proposal";
import { proposalFieldClassName } from "./proposal-form-constants";
type ProposalStepPersonalProps = {
  control: Control<ProposalFormValues>;
  errors: FieldErrors<ProposalFormValues>;
  register: UseFormRegister<ProposalFormValues>;
};
export function ProposalStepPersonal(t0) {
  const $ = _c(22);
  const {
    control,
    errors,
    register
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <label className="sr-only" htmlFor="name">Seu nome</label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== register) {
    t2 = register("name");
    $[1] = register;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Input {...t2} className={proposalFieldClassName} data-proposal-animate={true} id="name" placeholder="Seu nome" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== errors.name) {
    t4 = errors.name && <p className="-mt-1 text-sm text-red-300" data-proposal-animate={true}>{errors.name.message}</p>;
    $[5] = errors.name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <label className="sr-only" htmlFor="email">Seu email</label>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== register) {
    t6 = register("email");
    $[8] = register;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <Input {...t6} className={proposalFieldClassName} data-proposal-animate={true} id="email" placeholder="Seu email" type="email" />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== errors.email) {
    t8 = errors.email && <p className="-mt-1 text-sm text-red-300" data-proposal-animate={true}>{errors.email.message}</p>;
    $[12] = errors.email;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== control) {
    t9 = <Controller control={control} name="phone" render={_temp} />;
    $[14] = control;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <div className="space-y-4">{t1}{t3}{t4}{t5}{t7}{t8}{t9}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp(t0) {
  const {
    field,
    fieldState
  } = t0;
  return <div data-proposal-animate={true}><label className="sr-only" htmlFor="phone">Seu Whatsapp</label><div className="relative"><Input className={`${proposalFieldClassName} pr-14`} id="phone" inputMode="numeric" onChange={event => field.onChange(formatPhone(event.target.value))} placeholder="Seu Whatsapp" value={field.value ?? ""} /><Image alt="" aria-hidden="true" className="pointer-events-none absolute right-4 top-1/2 size-6 -translate-y-1/2 opacity-65 grayscale" height={24} src="/assets/socials/icon-whatsapp-green.svg" width={24} /></div>{fieldState.error && <p className="mt-2 text-sm text-red-300">{fieldState.error.message}</p>}</div>;
}